import { render, staticRenderFns } from "./HrFaceDatabasePhoto.vue?vue&type=template&id=422a7192&scoped=true&"
import script from "./HrFaceDatabasePhoto.vue?vue&type=script&lang=js&"
export * from "./HrFaceDatabasePhoto.vue?vue&type=script&lang=js&"
import style0 from "./HrFaceDatabasePhoto.vue?vue&type=style&index=0&id=422a7192&scoped=true&lang=css&"
import style1 from "./HrFaceDatabasePhoto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a7192",
  null
  
)

export default component.exports